<script>

export default {
  name: 'agency-menu',
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['account/getAccess']
    }
  }
}
</script>

<template>
  <b-dropdown
    :hoverable="true"
    aria-role="list"
    class="app-header__dropdown"
    position="is-bottom-left"
  >
    <button
      slot="trigger"
      class="app-header__dropdown-button button"
    >
      <span>Агентствам</span>
      <b-icon icon="menu-down" />
    </button>
    <b-dropdown-item
      v-if="!isUserLoggedIn"
      :has-link="true"
      :disabled="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Стать агентом
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :to="{
          name: 'Events'
        }"
      >
        Вебинары и мероприятия
      </router-link>
    </b-dropdown-item>
  </b-dropdown>
</template>
